import { AccordionContext } from "common/contexts";
import { classNames } from "common/functions";
import PropTypes from "prop-types";
import { isValidElement, useCallback, useContext } from "react";
import { FiChevronDown } from "../Icon/fi/FiChevronDown";

/**
 * contexts
 */

/**
 * Accordions
 */
import AccordionItem from "./accordion-item";

/** ========== */

/**
 * @param {Object} icon icon props for custom icon on accordion
 * @param {number} icon.className icon class that position of icon
 * @param {string} icon.openClass icon position on accordion opened
 * @param {string} icon.openClass icon position on accordion closed
 * @param {} myObj.c description
 */
const Accordion = ({
  list,
  defaultActiveKey,
  multipleOpen = false,
  icon,
  children,
  ...props
}) => {
  const { active } = useContext(AccordionContext);
  const IconElement = useCallback(
    (open) => {
      const IconTag = icon || FiChevronDown;
      if (isValidElement(IconTag)) {
        return IconTag;
      } else if (Object.keys(IconTag).length > 0) {
        return (
          <div
            className={
              IconTag.wrapperClass ||
              classNames(
                IconTag.wrapperSubclass,
                "absolute right-6 top-4 transform align-middle "
              )
            }
          >
            <IconTag.Icon
              className={classNames(
                IconTag.className,
                `${
                  open
                    ? IconTag.openClass || "rotate-180"
                    : IconTag.closeClass || "rotate-0"
                } transition-all duration-200`
              )}
              size={IconTag.size || 20}
            />
          </div>
        );
      } else {
        return (
          <IconTag
            className={`absolute right-6 top-4 transform align-middle  ${
              open ? "rotate-180" : "rotate-0"
            } transition-all duration-200`}
            size={20}
          />
        );
      }
    },
    [icon]
  );
  return (
    <AccordionItem
      multipleOpen={multipleOpen}
      defaultActiveKey={`${active || ""}`}
      className={"gleads-accordion " + (props.className || "")}
    >
      {list?.length > 0 &&
        list.map((item, index) => (
          <AccordionItem.Item
            key={index}
            eventKey={`${item.name.toLowerCase().split(" ").join("-")}`}
            className={
              (props.accordionClass && `${props.accordionClass}`) || `last:mb-0`
            }
          >
            {({ open }) => (
              <>
                <AccordionItem.Button
                  className={classNames(
                    "relative w-full cursor-pointer  transition-colors duration-200",
                    open
                      ? props.buttonWrapperClass?.open ||
                          "bg-gleads-oxfordBlue-800 text-white"
                      : props.buttonWrapperClass?.close || "bg-white",
                    props.buttonClass ||
                      "rounded-md py-4 px-6 pr-4 text-left font-semibold shadow-[0px_5px_20px_rgba(203,203,203,0.2)]"
                  )}
                >
                  {IconElement(open)}
                  <div
                    className={
                      props.buttonContentClass
                        ? open
                          ? props.buttonContentClass.open
                          : props.buttonContentClass.close
                        : `pr-10 `
                    }
                    dangerouslySetInnerHTML={{ __html: item.name }}
                  ></div>
                </AccordionItem.Button>
                {children ? (
                  <AccordionItem.Panel
                    className={`gleads-accordion-panel transition-all ${props.panelClass} `}
                  >
                    {children}
                  </AccordionItem.Panel>
                ) : (
                  <AccordionItem.Panel
                    className={`gleads-accordion-panel transition-all duration-200 ${
                      props.panelClass?.wrapperClass || "mt-4"
                    } `}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: item.content }}
                      className={
                        props.panelClass?.contentClass || "mb-4 space-y-4"
                      }
                    />
                  </AccordionItem.Panel>
                )}
              </>
            )}
          </AccordionItem.Item>
        ))}
    </AccordionItem>
  );
};

export default Accordion;
Accordion.propTypes = {
  icon: PropTypes.object,
  list: PropTypes.array,
  multipleOpen: PropTypes.bool,
  defaultActiveKey: PropTypes.number,
};

Accordion.defaultProps = {
  list: [],
  multipleOpen: false,
  defaultActiveKey: null,
};

/** ========== */
